{
    const button = document.querySelector('.btnText');
    const content_box = document.querySelector('.product__description_inner');

    if (button && content_box) {
        if (content_box.textContent.length < 293 ) {
            button.classList.add("hidden")
        }
    }


    if (button && content_box) {
        button.addEventListener('click', function () {
            if (content_box.classList.contains('text_box')) {
                content_box.classList.remove('text_box');
                button.textContent = 'Read More...';
            } else {
                content_box.classList.add('text_box');
                button.textContent = 'Read Less...';
            }
        });
    }
}

// on click, toggle the active class on the accordion items


{
  window.setGridHeight = (selector) => {
    let gridOffsets = [];
    let gridRowOffsets = []
 
    gridOffsets = Array.from(document.querySelectorAll(selector)).map((element,index) => {
      let grid = element.closest('.grid__item') || element.closest('[data-equal]');
      element.removeAttribute('style');
      return {
        selector:element,
        selectorHeight: element.offsetHeight,
        offsetTop: grid.offsetTop,
      }
    });
 
    let offsets = gridOffsets.map(element => element.offsetTop);
    gridRowOffsets = [...new Set(offsets)];
 
    gridRowOffsets.forEach(rowOffset => {
      let rowGrids = gridOffsets.filter(grid => (grid.offsetTop == rowOffset));
      let comanElementHeight = Math.max.apply(Math,(rowGrids.map(ele => ele.selectorHeight)));
      rowGrids.forEach(grid => {
        grid.selector.style.minHeight = comanElementHeight+'px';
      });
    });
  }
 
 setTimeout(() => {
    matchHeightCallback();
  }, 2000)
  
  window.addEventListener('resize', function(event){
    matchHeightCallback();
  });
 
  let matchHeightCallback = () => {
    window.setGridHeight('.product-grid .card__heading'); 
  }
  matchHeightCallback();
}
{
  document.documentElement.className = document.documentElement.className.replace('no-js', 'js');
      if (Shopify.designMode) {
        document.documentElement.classList.add('shopify-design-mode');
      }
      document.documentElement.style.setProperty('--viewport-height', window.visualViewport.height + 'px');
      document.documentElement.style.setProperty('--viewport-width', window.visualViewport.width + 'px');
 
      
      function getBroswerDetails() {
        //Checking the user's OS and Browser
        if ((navigator.userAgent).includes("Android")) {
            document.querySelector("html").classList.add("android");
        } else if ((navigator.userAgent).includes("Mac")) {
            document.querySelector("html").classList.add("mac");
        } else {
            document.querySelector("html").classList.add("windows");
        }
    
    
        //-- Browser --//
        var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
        var isFirefox = typeof InstallTrigger !== 'undefined';
        var isSafari = /constructor/i.test(window.HTMLElement) || (function(p) {
            return p.toString() === "[object SafariRemoteNotification]";
        })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
        var isIE = /*@cc_on!@*/ false || !!document.documentMode;
        var isEdge = !isIE && !!window.StyleMedia;
        var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
        var isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1);
        var isBlink = (isChrome || isOpera) && !!window.CSS;
        if (isFirefox) {
            document.querySelector("html").classList.add("isFirefox")
        } else if (isChrome) {
            document.querySelector("html").classList.add("isChrome")
        } else if (isSafari) {
            document.querySelector("html").classList.add("isSafari")
        } else if (isOpera) {
            document.querySelector("html").classList.add("isOpera")
        } else if (isIE) {
            document.querySelector("html").classList.add("isIE")
        } else if (isEdge) {
            document.querySelector("html").classList.add("isEdge")
        } else if (isEdgeChromium) {
            document.querySelector("html").classList.add("isEdgeChromium")
        } else {
            document.querySelector("html").classList.add("isBlink")
        }
    }
      getBroswerDetails();
 
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
        // true for mobile device
        document.querySelector("html").classList.add("mobile");
      }
}

{
  class sliderNavigation extends HTMLElement {
    constructor() {
        super();
        this.navigationButtons = this.querySelectorAll('.js-navigation-dots');
        this.blockPanels = this.querySelectorAll('.js-panel-block');
        this.blockWrapper = this.querySelector('.panel_block');
        this.observeBlockPanels()
        this.addDotClickHandlers()
    }
    observeBlockPanels() {
        const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const index = Array.from(this.blockPanels).indexOf(entry.target);
                this.navigationButtons.forEach(dot => dot.classList.remove('active'));
                if (index !== -1) {
                    this.navigationButtons[index].classList.add('active');
                }
            } else {
                const index = Array.from(this.blockPanels).indexOf(entry.target) - 1;
                this.navigationButtons.forEach(dot => dot.classList.remove('active'));
                if (index !== -1) {
                    this.navigationButtons[index].classList.add('active');
                }
            }
        });
        }, {
        threshold: 0.5
        });
        this.blockPanels.forEach(el => observer.observe(el));
    }
    addDotClickHandlers() {
        this.navigationButtons.forEach((dot, index) => {
            dot.addEventListener('click', () => {
                const targetPanel = this.blockPanels[index];
                if (targetPanel) {
                    targetPanel.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            });
        });
    }
    
  }
customElements.define("slider-navigation", sliderNavigation);
}




{ 
if(window.location.href.includes("selfcare")){
gsap.registerPlugin(ScrollTrigger);

function setupRegionsAnimation() {
    if (window.innerWidth < 993) return;
  const regions = document.querySelectorAll(".region");

  // Reset heights to auto before recalculating
  regions.forEach(region => {
    region.style.height = "auto";
  });

  // Set correct heights after DOM update
  regions.forEach(region => {
    region.style.height = region.scrollHeight + "px";
  });

  // Kill any existing ScrollTriggers and timelines
  ScrollTrigger.getAll().forEach(trigger => trigger.kill());
  gsap.globalTimeline.clear();

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: ".accordion_block",
      start: "top top",
      end: "+=1000",
      scrub: 0.3,
      pin: true,
      pinSpacing: false,
      markers: false
    }
  });

  regions.forEach((region, i) => {
    const full = region.scrollHeight;
    if (full < 200) return;
    const collapsed = full * 0.2;

    tl.to(region, {
      height: collapsed,
      duration: 1,
      ease: "power1.inOut"
    }, i * 0.5);
  });
}

window.addEventListener("load", setupRegionsAnimation);
window.addEventListener("resize", () => {
  requestAnimationFrame(setupRegionsAnimation);
});
}
}